import { useState, useRef, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import "../Css/MenuUser.css"

export default function UserMenu({ userEmail }) {
  const [isOpen, setIsOpen] = useState(false)
  const menuRef = useRef(null)
  const navigate = useNavigate()

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const handleLogout = () => {
    // Borrar el token del localStorage
    localStorage.removeItem("authToken")
    
    // Borrar la cookie de userId
    document.cookie = "userId=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT"
    
    // Cerrar el menú
    setIsOpen(false)
    
    // Redirigir al login
    navigate("/login")
  }

  // Cerrar el menú cuando se hace clic fuera de él
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <div className="user-menu-container" ref={menuRef}>
      <button className="user-menu-trigger" onClick={toggleMenu}>
        <div className="user-avatar">
          {userEmail ? userEmail.charAt(0).toUpperCase() : "U"}
        </div>
        <span className="user-email">{userEmail || "Usuario"}</span>
        <span className={`dropdown-arrow ${isOpen ? "open" : ""}`}>▼</span>
      </button>

      {isOpen && (
        <div className="user-dropdown">
          <div className="dropdown-header">
            <div className="dropdown-user-info">
              <div className="dropdown-avatar">
                {userEmail ? userEmail.charAt(0).toUpperCase() : "U"}
              </div>
              <div className="dropdown-user-details">
                <span className="dropdown-user-email">{userEmail}</span>
                <span className="dropdown-user-role">Usuario</span>
              </div>
            </div>
          </div>
          <div className="dropdown-divider"></div>
          <ul className="dropdown-menu">
            <li className="dropdown-menu-item">
              <button className="dropdown-menu-button" onClick={handleLogout}>
                <span className="dropdown-menu-icon">🚪</span>
                <span>Cerrar sesión</span>
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  )
}
